// src/components/GuestInvitationCard.tsx
import React from "react";
import "./GuestInvitationCard.css";

export interface GuestInvitationData {
  name: string | undefined;
  invited: number | undefined;
  guests?: string[];
  table?: number;
}

export const GuestInvitationCard: React.FC<{ data: GuestInvitationData }> = ({
  data,
}) => {
  return (
    <div className="invitation-card">
      <span className="invitation-welcome">Bienvenidos</span>
      <div className="invitation-passes">
        N° PASES <span className="passes-number">{data.invited}</span>
      </div>
      <ul className="invitation-guests">
        <li>{data.name}</li>
        {data.guests?.map((g, i) => (
          <li key={i}>{g}</li>
        ))}
      </ul>
      <div className="invitation-table-label">MESA</div>
      <div className="invitation-table-number">{data.table}</div>
    </div>
  );
};
